import type { BindingGroupModel, InputGroupModel } from '../models';
import { hasInvalidCheckboxConstant } from '../../iota_applications/misc/checkboxConstant';

const findInvalidBinding = (
    groups: BindingGroupModel[],
    path: BindingGroupModel[] = []
): { inputId: string; bindingIndex: number; path: BindingGroupModel[] } | undefined => {
    for (const group of groups) {
        const currentPath = [...path, group];
        for (const input of group.inputs) {
            const bindingIndex = input.bindings.findIndex(binding => hasInvalidCheckboxConstant(input.meta, binding));
            if (bindingIndex !== -1) {
                return { inputId: input.inputId, bindingIndex, path: currentPath };
            }
        }
        const child = findInvalidBinding(group.childBindingGroups, currentPath);
        if (child) {
            return child;
        }
    }
    return undefined;
};

export const getInvalidBindingNavigation = (inputGroups: InputGroupModel[]) => {
    for (const inputGroup of inputGroups) {
        const invalid = findInvalidBinding(inputGroup.bindingGroups);
        if (!invalid) {
            continue;
        }
        const [section] = invalid.path;
        const childGroups: { group: BindingGroupModel; openIds: string[] }[] = [];
        for (let index = 1; index < invalid.path.length; index++) {
            const parent = invalid.path[index - 1];
            const child = invalid.path[index];
            childGroups.push({
                group: parent,
                openIds: [...new Set([...parent.openChildBindingGroups, child.bindingGroupId])]
            });
        }
        return {
            inputGroup,
            openBindingGroupIds: [...new Set([...inputGroup.openBindingGroupIds, section.bindingGroupId])],
            childGroups,
            target: { tabKey: inputGroup.tabKey, inputId: invalid.inputId, bindingIndex: invalid.bindingIndex }
        };
    }
    return undefined;
};
